import { render, staticRenderFns } from "./DataSchema.vue?vue&type=template&id=67a09a20&"
import script from "./DataSchema.vue?vue&type=script&lang=ts&"
export * from "./DataSchema.vue?vue&type=script&lang=ts&"
import style0 from "./DataSchema.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports